import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
const OfferSuccess = ({data,sellerConcession,offerDetails,paylaodData}) => {

  const navigate = useNavigate();

  const [total, setTotal] = useState(0);

  const calculateTotal = () => {
    const totalAmount = sellerConcession.reduce((sum, item) => {
      return sum + parseFloat(item.amount || 0);
    }, 0);
    setTotal(totalAmount);
  };

  useEffect(() => {
    if (sellerConcession?.length > 0) {
      calculateTotal();
    }
  }, [sellerConcession]);

  function formatRupeeToUSD(amount) {
    const usdFormatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
    });
    return usdFormatter.format(amount);
  }

  return (
    <div className="congrats-page">
      <div className="congratulations">
        <h1>Congratulations!</h1>
        <p className="congrats-p">
          Your offer of{" "}
          <b>{data?.offerPricingInformation?.offerAmountFormatted}</b> was
          placed successfully.
        </p>
        <p>We'll keep you updated on the status of your offer.</p>
      </div>
      <div className="offer-summary">
        <h3 className="summary-heading">Offer Summary</h3>
        <div className="summary-details">
          <p className="place-time">
            {" "}
            <span className="placed-at">Placed at </span>
            {data?.offerPlaceTime}
          </p>
          <div className="info">
            <h5 className="congrats-buyeragent-info">
              Buyer/Agent Information
            </h5>
            <section className="buyer-agent-summary">
              <div className="buyer">
                <p className="heading">Buyer</p>
                <p className="details">
                  {data?.offerUserDetail?.buyerDetail?.firstName}{" "}
                  {data?.offerUserDetail?.buyerDetail?.lastName}
                </p>
              </div>
              {data?.offerUserDetail?.agentDetail?.firstName && (
                <div className="buyer">
                  <p className="heading">Buyer's Agent</p>
                  <p className="details">
                    {data?.offerUserDetail?.agentDetail?.firstName}{" "}
                    {data?.offerUserDetail?.agentDetail?.lastName}
                  </p>
                </div>
              )}
            </section>
          </div>
          <div className="row p-2 ">
            <div className="offer-amount col-12 col-sm-6">
              <div className="amount-details">
                <h3 className="congrats-amt-details">Offer Amount Details</h3>
                <div className="row">
                  <p className="congrats-amt-title col-5">Your Offer Amount</p>
                  <p className="congrats-amt-val col-4">
                    {data?.offerPricingInformation?.offerAmountFormatted}
                  </p>
                </div>
                <div className="row ">
                  <p className="congrats-amt-title col-5">Technology fee</p>
                  <p className="congrats-amt-val col-4">
                    {data?.offerPricingInformation?.technologyFeesFormatted}
                  </p>
                </div>
                <div className="row ">
                  <p className="congrats-amt-title col-5">
                    Earnest Money Deposit
                  </p>
                  <p className="congrats-amt-val col-4">
                    {
                      data?.offerPricingInformation
                        ?.earnestMoneyDepositFormatted
                    }
                  </p>
                </div>

                <div className="row bordertotal">
                  <p className="congrats-total-due col-5">Total Due</p>
                  <p className="congrats-total-val col-4">
                    {data?.offerPricingInformation?.totalDuesFormatted}
                  </p>
                </div>
                <p className="mb-0 hold-congrats-offer">
                  Hold this offer as backup for{" "}
                  {offerDetails?.backupOfferDaysSelected} days.
                </p>
              </div>
            </div>
            {
              sellerConcession?.length>0 &&
            <div className="offer-amount col-12 col-sm-6">
              <h3 className="congrats-amt-details">
                Seller Concession Request
              </h3>
              <div className="row">
                <div className="col-4 congrats-amt-title-seeler">Type</div>
                <div className="col-4 congrats-amt-title-seeler">Amount</div>
                <div className="col-4 congrats-amt-title-seeler  ">Note</div>
              </div>
              {sellerConcession?.map((data) => (
                <>
                  <div className="row">
                    <div className="col-4 congrats-amt-title">{data?.desc}</div>
                    <div className="col-4 congrats-amt-val">
                      {formatRupeeToUSD(data?.amount)}
                    </div>
                    <div className="col-4 congrats-amt-val">{data?.note}</div>
                  </div>
                </>
              ))}
              <div className="row mt-1">
                <div className="col-4 total-cons-heading">Total Concessions</div>
                <div className="col-4 congrats-amt-val-to">{formatRupeeToUSD(total)}</div>
              </div>
            </div>
            }
          </div>
        </div>
        {
          (paylaodData?.bidContigencyBuyerChosen?.length>0 && paylaodData?.bidContigencyBuyerChosen?.length>1) &&
        <div className="mortage-div container pb-3">
          <h3 className="congrats-amt-details">Seller Contigencies</h3>
          {
            paylaodData?.bidContigencyBuyerChosen?.map(item=> 
              <li className="mortgage-heading">{item?.comment}</li>

            )
          }
        </div>
        }
        {/* {paylaodData?.offerDetail?.finacingAndClosingDetail
          ?.paymentTypeSelected?.[0] === "MORTGAGE" && ( */}
          <div className="mortagage-div container px-3 px-sm-3">
            <h3 className="congrats-amt-details">Financing and Closing</h3>
            <div className="d-flex justify-content-between flex-wrap g10 w90p">
              <div className="financing1">
                <p className="mortgage-heading">Financing</p>
                <p className="mortgage-val">
                  {
                    paylaodData?.offerDetail?.finacingAndClosingDetail
                      ?.paymentTypeSelected?.[0]
                  }
                </p>
              </div>
              <div className="financing1">
                <p className="mortgage-heading">Offer Expires In</p>
                <p className="mortgage-val">{paylaodData?.offerDetail?.offerExpiryDays }{" "}days</p>
              </div>
              <div className="financing1">
                <p className="mortgage-heading">Must Close Within</p>
                <p className="mortgage-val">
                  {paylaodData?.offerDetail?.finacingAndClosingDetail
                    ?.closingDaysSelected+" days" || "40 days"}
                </p>
              </div>
              <div className="financing1">
                <p className="mortgage-heading">Closing Handled By</p>
                <p className="mortgage-val">
                  {paylaodData?.offerDetail?.finacingAndClosingDetail
                    ?.closingOptionDetailSelected?.closingOption ===
                  "SELLER_PAYS"
                    ? "Seller"
                    : "Buyer"}
                </p>
              </div>
            </div>
          </div>
        {/* )} */}
        <p className="p-2 mb-0 congrats-note">
          <b>Note:</b>An earnest money deposit of{" "}
          {data?.offerPricingInformation?.earnestMoneyDepositFormatted} is due
          after you sign the Purchase & Sale Agreement
        </p>

        {/* <div className="text-center m-3">
          <button className="btn btn-thm w-25" onClick={()=>navigate('/my-shopper/myOffers')}>Close</button>
        </div> */}
      </div>
    </div>
  );
};

export default OfferSuccess;
